<template>
  <div>
    <b-card>
      <b-row v-if="!passChanged">
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <b-alert v-model="showDismissibleAlert" variant="danger">{{error}}</b-alert>
          <div>
            <b-form-group label="رمز عبور فعلی" label-for="oldPass">
              <b-form-input
                id="oldPass"
                type="password"
                v-model="$v.pass.old.$model"
                :state="validateState('old')"
                placeholder="رمز عبور فعلی را وارد کنید"
              ></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">رمز عبور فعلی اجباری است</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="رمز عبور جدید" label-for="pass">
              <b-form-input
                id="pass"
                type="password"
                v-model="$v.pass.new.$model"
                :state="validateState('new')"
                placeholder="رمز عبور جدید وارد کنید"
              ></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">رمز عبور جدید اجباری است</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="تکرار رمز عبور جدید" label-for="RePass">
              <b-form-input
                id="RePass"
                type="password"
                v-model="$v.pass.reNew.$model"
                :state="validateState('reNew')"
                placeholder="تکرار رمز عبور جدید وارد کنید"
              ></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">تکرار رمز عبور اجباری است</b-form-invalid-feedback>
            </b-form-group>
            <b-button variant="warning" href="/dashboard">انصراف</b-button>
            <b-button class="ml-3" variant="success" @click="SavePass()">تغییر رمز عبور</b-button>
          </div>
        </div>
        <div class="col-md-4"></div>
      </b-row>
      <b-row v-if="passChanged">
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <b-alert variant="success" show >
            {{error}}
            <div class="mt-6">
              <b-button href="/dashboard" variant="primary" size="sm">بازگشت به صفحه اصلی</b-button>
            </div>
          </b-alert>
        </div>
        <div class="col-md-4"></div>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
import httpHelper from "../../helpers/httpHelper";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
  name: "userConf",
  mixins: [validationMixin],
  data: function() {
    return {
      pass: {
        old: "",
        new: "",
        reNew: ""
      },
      passChanged: false,
      showDismissibleAlert: false,
      error: null
    };
  },
  validations: {
    pass: {
      old: {
        required,
        minLength: minLength(3)
      },
      new: {
        required,
        minLength: minLength(6)
      },
      reNew: {
        required,
        minLength: minLength(6)
      }
    }
  },
  components: {},
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تغییر رمز عبور" }]);
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.pass[name];
      return $dirty ? !$error : null;
    },
    SavePass() {
      this.$v.pass.$touch();
      if (this.$v.pass.$anyError) {
        return;
      }
      var data = {
        old: this.$v.pass.old.$model,
        new: this.$v.pass.new.$model,
        reNew: this.$v.pass.reNew.$model
      };
      httpHelper.postData("users/ChangePass", data).then(res => {
        if (res.success == false) {
          this.error = res.error;
          this.showDismissibleAlert = true;
        } else {
          this.passChanged = true;
          this.error = "رمز عبور با موفقیت تغییر کرد";
          this.showDismissibleAlert = true;
        }
      });
    }
  }
};
</script>
